// extracted by mini-css-extract-plugin
module.exports = {"container":"footer_container__lONVT","line":"footer_line__B8fLy","grow":"footer_grow__IzUpL","about":"footer_about__2iXRq","space":"footer_space__1xsp6"};